module.exports = function() {
    return {
        run() {
            $('body').on('click', '.pulse', function() {
                if ($('#mobile-state').is(':hidden')) {
                    $('.pulse').hide(300);
                    $('.pulse-popup').show(300);
                }
            });
            $('body').on('click', '.pulse-popup .fa-close', function() {
                $('.pulse-popup').hide(300);
                setTimeout(function() {
                    $('.pulse').css('display','flex');
                },300);
                $('.input-phone').val('');
            });
        }
    }
}
